/*
 * ls-elements
 * Copyright (C) 2024 Libriciel SCOP
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import {Component} from '@angular/core';
import {FIELD_VIEW_PROVIDERS, FieldsBaseComponent} from "../../fields-base/fields-base.component";
import {ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {FieldsErrorsComponent} from "../../fields-errors/fields-errors.component";

@Component({
  selector: 'ls-textarea-field',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FaIconComponent,
    FieldsErrorsComponent
  ],
  templateUrl: './textarea-field.component.html',
  styleUrl: './textarea-field.component.scss',
  viewProviders: FIELD_VIEW_PROVIDERS
})
export class TextareaFieldComponent extends FieldsBaseComponent<string> {
}
